/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminTicketScanResponse } from './AdminTicketScanResponse';
import {
    AdminTicketScanResponseFromJSON,
    AdminTicketScanResponseFromJSONTyped,
    AdminTicketScanResponseToJSON,
} from './AdminTicketScanResponse';

/**
 * 
 * @export
 * @interface PlayerTicketScans
 */
export interface PlayerTicketScans {
    /**
     * 
     * @type {Array<AdminTicketScanResponse>}
     * @memberof PlayerTicketScans
     */
    ticketScans: Array<AdminTicketScanResponse>;
    /**
     * 
     * @type {number}
     * @memberof PlayerTicketScans
     */
    totalResults: number;
    /**
     * 
     * @type {number}
     * @memberof PlayerTicketScans
     */
    resultEnd: number;
    /**
     * 
     * @type {number}
     * @memberof PlayerTicketScans
     */
    resultStart: number;
    /**
     * 
     * @type {string}
     * @memberof PlayerTicketScans
     */
    playerLookupId: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerTicketScans
     */
    playerId: string;
}

/**
 * Check if a given object implements the PlayerTicketScans interface.
 */
export function instanceOfPlayerTicketScans(value: object): value is PlayerTicketScans {
    if (!('ticketScans' in value) || value['ticketScans'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    if (!('resultEnd' in value) || value['resultEnd'] === undefined) return false;
    if (!('resultStart' in value) || value['resultStart'] === undefined) return false;
    if (!('playerLookupId' in value) || value['playerLookupId'] === undefined) return false;
    if (!('playerId' in value) || value['playerId'] === undefined) return false;
    return true;
}

export function PlayerTicketScansFromJSON(json: any): PlayerTicketScans {
    return PlayerTicketScansFromJSONTyped(json, false);
}

export function PlayerTicketScansFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerTicketScans {
    if (json == null) {
        return json;
    }
    return {
        
        'ticketScans': ((json['ticketScans'] as Array<any>).map(AdminTicketScanResponseFromJSON)),
        'totalResults': json['totalResults'],
        'resultEnd': json['resultEnd'],
        'resultStart': json['resultStart'],
        'playerLookupId': json['playerLookupId'],
        'playerId': json['playerId'],
    };
}

export function PlayerTicketScansToJSON(value?: PlayerTicketScans | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ticketScans': ((value['ticketScans'] as Array<any>).map(AdminTicketScanResponseToJSON)),
        'totalResults': value['totalResults'],
        'resultEnd': value['resultEnd'],
        'resultStart': value['resultStart'],
        'playerLookupId': value['playerLookupId'],
        'playerId': value['playerId'],
    };
}

